import Link from 'next/link'
import { css, Theme } from '@emotion/react'
import { Box, Typography, Breadcrumbs, Divider } from '@mui/material'
import { parseISO, format } from 'date-fns'
import { DataObjectOutlined } from '@mui/icons-material'

type Props = {
  title: string
  date?: string
}

const NewsHead: React.FC<Props> = ({ title, date }) => {
  const publishDates = parseISO(date ?? '2021-05-17T00:56:58.487363+00:00')

  return (
    <>
      <Box mx={3} css={styles.header}>
        <Breadcrumbs maxItems={3} aria-label='breadcrumb'>
          <Link href='/' passHref>
            <a css={styles.breadHome}>Home</a>
          </Link>
        </Breadcrumbs>
        <Typography variant='h4' component='h4' css={styles.dateContainer}>
          <time dateTime={date} css={styles.publishDate}>
            {format(publishDates, 'yyyy年M月d日')}
          </time>
        </Typography>
        <Typography variant='h1' component='h1' css={styles.title}>
          {title}
        </Typography>
        <Divider />
      </Box>
    </>
  )
}

const styles = {
  header: (theme: Theme) => css``,
  breadHome: (theme: Theme) => css`
    color: ${theme.palette.primary.main};
    font-family: 'Noto sans JP', sans-serif;
    font-weight: 500;
    font-size: 0.9rem;
    &:before {
      content: '\\f015';
      margin-right: 5px;
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      font-size: 0.9rem;
    }
    @media (min-width: 960px) {
      font-size: 1rem;
      &:before {
        font-size: 1rem;
      }
    }
  `,
  title: (theme: Theme) => css`
    font-family: 'Noto Sans JP', sans-serif;
    font-size: 2rem;
    font-weight: 700;
    margin: 0 0 30px;
    color: ${theme.palette.primary.main};
    @media (min-width: 960px) {
      font-size: 3rem;
    }
  `,
  dateContainer: css`
    padding: 20px 0 5px;
  `,
  publishDate: (theme: Theme) => css`
    font-size: 1rem;
    font-weight: 500;
    color: ${theme.palette.primary.main};
    @media (min-width: 960px) {
      font-size: 1.3rem;
    }
  `,
}

export default NewsHead
